import axios from 'axios'
import { API_URL } from '../config/envs'
import store from '../store'

const _baseUrl = API_URL

const httpClient = axios.create({
  baseURL: _baseUrl,
})

httpClient.interceptors.request.use(async (config) => {
  const session = await store().dispatch('session/fetchSession')
  const token = session.accessToken.jwtToken
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export default httpClient
